/**
* Services Animated JS
* -----------------------------------------------------------------------------
*
* All the JS for the Services Animated component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'services-animated',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.prototype-slider' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        appendArrows: $( '.prototype-slider__nav-wrapper' ),
        nextArrow: '<div class="icon-wrapper next flex items-center justify-center cursor-pointer pl-4"><svg class="icon icon-arrow-right text-brand-charcoal rounded-full p-4 h-12 w-12"><use xlink:href="#icon-arrow-right"></use></svg></div>',
        prevArrow: '<div class="icon-wrapper prev flex items-center justify-center cursor-pointer pr-4"><svg class="icon icon-arrow-right text-brand-charcoal rounded-full p-4 h-12 w-12"><use xlink:href="#icon-arrow-right"></use></svg></div>',
      } );


      $( '.prototype-slider' ).on( 'afterChange', function( event, slick, slideNum ) {
        let played = false;
        function playVid() {
          if ( played === false ) {
            $( '#part-video-'+slideNum+'' )[0].play();
            played = true;
          }
        }
        playVid();
        const tl = gsap.timeline();
        tl.to( '#part-video-'+slideNum+'', {duration: 2, opacity: 0, delay: 2} );
        tl.to( '.parts-'+slideNum+', .title-panel-'+slideNum+'', {duration: 2, opacity: 1}, '-=2' );
      } );

      let firstPlayed = false;

      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.animated-canvas',
          start: 'top 50%',
          onEnter: function playVid() {
            if ( firstPlayed === false ) {
              $( '#part-video-0' )[0].play();
              firstPlayed = true;
            }
          },
        },
      } );

      tl.to( '#part-video-0', {duration: 2, opacity: 0, delay: 2} );
      tl.to( '.parts-0, .title-panel-0', {duration: 2, opacity: 1}, '-=2' );


      document.querySelectorAll( '.text-trigger' ).forEach( ( trigger ) => {
        trigger.addEventListener( 'toggleAfter', ( event ) => {
          $( '.animated-canvas' ).toggleClass( 'active' );
        }, false );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'services-animated', COMPONENT );
} )( app );

